import React from 'react';
import PropTypes from 'prop-types';
import Currency from '../../../_utils/tools/currency';
import ListQuantityFieldHandlers from '../../common/list-quantity-field-handlers';
import NumberInputField from '../../common/number-input-field';

import RawPhotoLowResolutionBadge from '../../common/photo-quality/raw-photo-low-resolution-badge';
import CroppedTooSmallBadge from '../../common/photo-quality/cropped-too-small-badge';
import RecommendedPrintSizeBadge from '../../common/photo-quality/recommended-print-size-badge';

const ItemSize = (props) => {
  const {
    rootId,
    sizeKey,
    title,
    options,
    price,
    disabled,
    handleQuantityChange,
    quantity,
    badgeType,
  } = props;
  const inputId = `size-quantity-change-${rootId}-${sizeKey}`;
  const badgeId = badgeType
    ? `item-size-badge-${rootId}-${sizeKey}`
    : undefined;

  return (
    <li>
      <div className="form-inline mb-2">
        <div className="list-item__size form-group justify-content-end w-100">
          {badgeType === 'raw_photo_low_res' && (
            <RawPhotoLowResolutionBadge
              id={badgeId}
              tooltipPosition="left"
              tooltipCSSClasses="desktop"
            />
          )}
          {badgeType === 'cropped_too_small' && (
            <CroppedTooSmallBadge
              id={badgeId}
              tooltipPosition="left"
              tooltipCSSClasses="desktop"
            />
          )}
          {badgeType === 'recommended' && (
            <RecommendedPrintSizeBadge id={badgeId} className="mr-2" />
          )}

          <label htmlFor={inputId}>{title}</label>
          {options.border && (
            <span className="list-item__size-border form-group flex-nowrap justify-content-end mr-2">
              Bordered
            </span>
          )}
          <NumberInputField
            id={inputId}
            min={0}
            max={999}
            value={quantity()}
            label={title}
            disabled={disabled}
            describedBy={badgeId}
            onChange={handleQuantityChange}
          />
          <span className="price-each text-muted">
            {Currency.format(price)}&nbsp;ea
          </span>
        </div>
      </div>
    </li>
  );
};

ItemSize.displayName = 'ItemSize';

ItemSize.propTypes = {
  sizeKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  options: PropTypes.object.isRequired,
  rootId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  price: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  handleQuantityChange: PropTypes.func.isRequired,
  quantity: PropTypes.func.isRequired,
  badgeType: PropTypes.oneOf([
    'raw_photo_low_res',
    'cropped_too_small',
    'recommended',
  ]),
};

ItemSize.defaultProps = {
  disabled: false,
  badgeType: null,
};

export default ListQuantityFieldHandlers(ItemSize);
